const DEFAULT_HIGH_LUMINANCE_COLOR = 'black'
const DEFAULT_LOW_LUMINANCE_COLOR = 'white'

export function getBetterContrastColor(hexColor: string): 'black' | 'white' {
  const hexToRgb = (hex: string): {r: number; g: number; b: number} => {
    const parsedHex = hex.replace('#', '')
    const bigint = parseInt(parsedHex, 16)
    return {
      r: (bigint >> 16) & 255,
      g: (bigint >> 8) & 255,
      b: bigint & 255
    }
  }

  const getLuminance = ({r, g, b}: {r: number; g: number; b: number}): number => {
    const toLinearColor = (channel: number): number => {
      const normalized = channel / 255
      return normalized <= 0.03928
        ? normalized / 12.92
        : Math.pow((normalized + 0.055) / 1.055, 2.4)
    }

    const R = toLinearColor(r)
    const G = toLinearColor(g)
    const B = toLinearColor(b)

    return 0.2126 * R + 0.7152 * G + 0.0722 * B
  }

  const rgb = hexToRgb(hexColor)
  const luminance = getLuminance(rgb)

  return luminance > 0.5 ? DEFAULT_HIGH_LUMINANCE_COLOR : DEFAULT_LOW_LUMINANCE_COLOR
}
